export const DARK_THEME = {
  bg: "#081525",
  bgPanel: "#081525",
  bgCard: "#0a1b36",
  bgHover: "#122a44",
  border: "#30404e",
  borderAccent: "#c0a060",
  accent: "#c0a060",
  accentHover: "#d0b170",
  text: "#f0f2f6",
  textMuted: "#a8b8cc",
  textDark: "#081525",
  toggle: "#30404e",
  toggleActive: "#c0a060",
  toggleKnob: "#f0f2f6",
  danger: "#ef4444",
  dangerHover: "#ff6060",
};

export const LIGHT_THEME = {
  bg: "#f5f3ef",
  bgPanel: "#ffffff",
  bgCard: "#ffffff",
  bgHover: "#ede9e3",
  border: "#e5e2dc",
  borderAccent: "#d4a520",
  accent: "#c4941a",
  accentHover: "#a87c10",
  text: "#1a1a1a",
  textMuted: "#6b7280",
  textDark: "#111827",
  toggle: "#e5e2dc",
  toggleActive: "#c4941a",
  toggleKnob: "#ffffff",
  danger: "#dc2626",
  dangerHover: "#b91c1c",
};
